import React from 'react';
import HomeWorkspace from './home/HomeWorkspace';
export function PortalSelection(props) { return <HomeWorkspace key={props.user?.id || 'signed-out'} {...props}/>; }
export default PortalSelection;
